import React, { useEffect, useState } from "react";
import moment from "moment";

const RealTimeDate = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return <span>{moment(currentTime).format("MMMM Do YYYY, h:mm:ss a")}</span>;
};
export default RealTimeDate;
